import { create } from 'zustand'

import { deleteFile, getFilesUser, postIndexFile, updateFileMeta } from '../api/files'
import {
    FileObject,
    FileObjectIndexModel,
    FileObjectIndexOutputDTO,
    FileObjectUpdateMetaModel,
    FileObjectUserFolderOutputDTO,
    FoDeleteApiV1UserFolderFileObjectDeleteParams,
    FoUserFolderApiV1UserFolderFileObjectGetParams,
} from '../swagger/dtoGateway'

interface FilesState {
    filesUser: FileObject[]
    fetchFilesUser: (
        params: FoUserFolderApiV1UserFolderFileObjectGetParams,
        isRefresh?: boolean,
    ) => Promise<FileObjectUserFolderOutputDTO>
    isLoadingFetchFilesUser: boolean
    errorFetchFiles?: string

    isDoneFileDelete: boolean
    fileDelete: (params: FoDeleteApiV1UserFolderFileObjectDeleteParams) => Promise<FileObject>
    isLoadingFileDelete: boolean
    errorFileDelete?: string

    setIndexFile: (data: FileObjectIndexModel) => Promise<FileObjectIndexOutputDTO>
    isLoadingSetIndexFile: boolean
    errorSetIndexFile?: boolean

    setFileUrlList: (fileUrl: string) => void
    fileUrlList: []

    isDoneChoiceFileUrl?: boolean
    setChoiceFileUrl: (isDone: boolean) => void

    fileUpdateMeta: (params: FileObjectUpdateMetaModel) => Promise<void>
    errorFileUpdateMeta?: string
}

export const useFilesStore = create<FilesState>((set, get) => ({
    filesUser: [],
    isLoadingFetchFilesUser: false,
    errorFetchFilesUser: undefined,
    fetchFilesUser: async (params, isRefresh) => {
        try {
            set({
                filesUser: undefined,
                isLoadingFetchFilesUser: isRefresh ? false : true,
                errorFetchFilesUser: undefined,
            })
            const data = await getFilesUser({ ...params, desc: true, order_by: 'last_modified' })

            set({
                filesUser: data.files,
                isLoadingFetchFilesUser: false,
            })
        } catch (error) {
            set({
                isLoadingFetchFilesUser: false,
                errorFetchFilesUser: 'Ошибка получения списка файлов',
            })
        }
    },

    setIsDoneFileDelete: (isDone) => {
        set({
            isDoneFileDelete: isDone,
        })
    },

    isDoneFileDelete: false,
    isLoadingFileDelete: false,
    errorFileDelete: undefined,
    fileDelete: async (params) => {
        try {
            set({
                isDoneFileDelete: false,
                errorFileDelete: undefined,
                isLoadingFileDelete: true,
            })
            await deleteFile(params)

            set({
                isDoneFileDelete: true,
                isLoadingFileDelete: false,
            })
        } catch (error) {
            set({
                errorFileDelete: 'Возникла ошибка',
                isLoadingFileDelete: false,
            })
        }
    },

    isLoadingSetIndexFile: false,
    errorSetIndexFile: undefined,
    setIndexFile: async (params) => {
        try {
            set({
                errorSetIndexFile: undefined,
                isLoadingSetIndexFile: true,
            })
            await postIndexFile(params)

            set({
                isLoadingSetIndexFile: false,
            })
        } catch (error) {
            set({
                errorSetIndexFile: 'Возникла ошибка',
                isLoadingSetIndexFile: false,
            })
        }
    },

    isDoneChoiceFileUrl: false,
    setChoiceFileUrl: (isDone) => {
        set({
            isDoneChoiceFileUrl: isDone,
        })
    },
    fileUrlList: [],
    setFileUrlList: (fileUrl) => {
        set({
            fileUrlList: fileUrl,
        })
    },

    errorFileUpdateMeta: undefined,
    fileUpdateMeta: async (params) => {
        try {
            set({
                errorFileDelete: undefined,
            })
            const { rag_enabled } = await updateFileMeta(params)

            set((state) => ({
                filesUser: state.filesUser.map((file) =>
                    file.prefix === params.prefix ? { ...file, rag_enabled } : file,
                ),
            }))
        } catch (error) {
            set({
                errorFileUpdateMeta: 'Возникла ошибка',
            })
        }
    },
}))
